module.exports = __webpack_public_path__ + "img/vlf.0ab6f73d.svg";